
import styled from 'styled-components';
import THEME from 'theme';
import { SectionCtaProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import Title_v2 from '@/components/molecules/Title/index';
import { Svg } from '@/components/styled';
import { List as IconList } from '@/public/img/icons';
import devices from '@/utilities/devices';
import { renderIcons, renderUnderline } from '@/utilities/functions';

const SectionCtaContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: .625rem 0;
`;

const CustomTitle = styled(Title_v2)`
	@media screen and (${devices.mobile}) {
		font-size: ${({ theme }) => theme.fontSize.XLARGE};
		padding: 0em;
	}
`;

const SectionCta = ({ SectionCtaData }: { SectionCtaData: SectionCtaProps }) => {
	return (
		<SectionCtaContainer>
			<Svg
				color={SectionCtaData.icon.color?.color}
				size={{ width: '64px', height: '64px' }}
			>
				{SectionCtaData.icon && renderIcons(SectionCtaData.icon.name, IconList)}
			</Svg>
			<CustomTitle
				align={SectionCtaData.title.alignedAt}
				fontSize={THEME.fontSize.XXLARGE}
				white={SectionCtaData.backgroundColor.color === 'prune'}
				underlineColor={SectionCtaData.title.underlineColor}
			>
				{renderUnderline(SectionCtaData.title.titlePieces)}
			</CustomTitle>
			{
				SectionCtaData.requiredButtons && (
					SectionCtaData.requiredButtons.map(
						(button, index) => (
							<Button_v2
								gtm_id={button.trackerId}
								href={button.url}
								key={index}
								openOnNewTab={button.newTab}
								text={button.text}
								version={button.variant}
							/>
						),
					)
				)
			}
		</SectionCtaContainer>
	);
};

export default SectionCta;
